import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { CheckIcon, ChevronRightIcon } from 'lucide-react';
export function TrialSignup() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    company: '',
    phone: '',
    password: '',
    confirmPassword: '',
    terms: false,
    newsletter: true
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Handle signup logic
    console.log(formData);
    window.location.href = '/trial-success';
  };
  const features = ["Accès à plus de 1000 appels d'offres par jour", 'Alertes personnalisées par email', 'Données historiques (1 an)', 'Export de documents (limité)', 'Support par email'];
  return <div className="min-h-screen bg-gray-50 flex flex-col" data-id="element-4359">
      <div className="flex-1" data-id="element-4360">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-4361">
          <Link to="/" className="inline-block mb-8" data-id="element-4362">
            <div className="relative" data-id="element-4363">
              <span className="text-2xl font-bold text-blue-900" data-id="element-4364">
                Elevate<span className="text-yellow-500" data-id="element-4365">IT</span>
              </span>
              <span className="text-sm font-normal ml-0.5 text-blue-600" data-id="element-4366">
                .fr
              </span>
              <div className="absolute -bottom-1 left-0 w-full h-0.5 bg-gradient-to-r from-yellow-500 to-transparent" data-id="element-4367"></div>
            </div>
          </Link>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-4368">
            <div data-id="element-4369">
              <h1 className="text-3xl font-extrabold text-gray-900 sm:text-4xl mb-6" data-id="element-4370">
                Essai gratuit de 7 jours
              </h1>
              <p className="text-lg text-gray-600 mb-8" data-id="element-4371">
                Accédez à toutes les opportunités d'affaires en Afrique sans
                engagement. Aucune carte de crédit requise.
              </p>
              <div className="bg-white rounded-xl shadow-sm p-6 mb-8" data-id="element-4372">
                <h3 className="text-lg font-semibold text-blue-900 mb-4" data-id="element-4373">
                  Ce qui est inclus :
                </h3>
                <ul className="space-y-3" data-id="element-4374">
                  {features.map((feature, index) => <li key={index} className="flex items-start" data-id="element-4375">
                      <div className="flex-shrink-0 h-5 w-5 bg-green-100 rounded-full flex items-center justify-center mr-3 mt-0.5" data-id="element-4376">
                        <CheckIcon size={12} className="text-green-600" data-id="element-4377" />
                      </div>
                      <span className="text-gray-700" data-id="element-4378">{feature}</span>
                    </li>)}
                </ul>
              </div>
              <div className="bg-blue-50 rounded-lg p-4 border border-blue-100 flex items-start" data-id="element-4379">
                <div className="flex-shrink-0 h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center mr-4" data-id="element-4380">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-4381">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-4382" />
                  </svg>
                </div>
                <div data-id="element-4383">
                  <p className="text-sm text-blue-800 mb-2 font-medium" data-id="element-4384">
                    Déjà client ?
                  </p>
                  <p className="text-sm text-blue-600 mb-3" data-id="element-4385">
                    Si vous avez déjà un compte, connectez-vous pour accéder à
                    votre espace client.
                  </p>
                  <Link to="/login" className="inline-flex items-center text-sm font-medium text-blue-700 hover:text-blue-800" data-id="element-4386">
                    Se connecter
                    <ChevronRightIcon size={16} className="ml-1" data-id="element-4387" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6 md:p-8" data-id="element-4388">
              <h2 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-4389">
                Créez votre compte d'essai
              </h2>
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-4390">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-4391">
                  <div data-id="element-4392">
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4393">
                      Prénom *
                    </label>
                    <input type="text" id="firstName" name="firstName" required value={formData.firstName} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm" data-id="element-4394" />
                  </div>
                  <div data-id="element-4395">
                    <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4396">
                      Nom *
                    </label>
                    <input type="text" id="lastName" name="lastName" required value={formData.lastName} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm" data-id="element-4397" />
                  </div>
                </div>
                <div data-id="element-4398">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4399">
                    Email professionnel *
                  </label>
                  <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm" placeholder="exemple@entreprise.fr" data-id="element-4400" />
                </div>
                <div data-id="element-4401">
                  <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4402">
                    Entreprise *
                  </label>
                  <input type="text" id="company" name="company" required value={formData.company} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm" data-id="element-4403" />
                </div>
                <div data-id="element-4404">
                  <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4405">
                    Téléphone
                  </label>
                  <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm" placeholder="+33 6 XX XX XX XX" data-id="element-4406" />
                </div>
                <div data-id="element-4407">
                  <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4408">
                    Mot de passe *
                  </label>
                  <input type="password" id="password" name="password" required minLength={8} value={formData.password} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm" data-id="element-4409" />
                  <p className="mt-1 text-xs text-gray-500" data-id="element-4410">
                    8 caractères minimum, avec au moins 1 chiffre et 1 lettre
                    majuscule
                  </p>
                </div>
                <div data-id="element-4411">
                  <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-4412">
                    Confirmer le mot de passe *
                  </label>
                  <input type="password" id="confirmPassword" name="confirmPassword" required value={formData.confirmPassword} onChange={handleChange} className="block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm" data-id="element-4413" />
                </div>
                <div className="space-y-3" data-id="element-4414">
                  <div className="flex items-start" data-id="element-4415">
                    <input type="checkbox" id="terms" name="terms" required checked={formData.terms} onChange={handleChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mt-1" data-id="element-4416" />
                    <label htmlFor="terms" className="ml-2 block text-sm text-gray-700" data-id="element-4417">
                      J'accepte les{' '}
                      <Link to="/cgv" className="text-blue-600 hover:text-blue-800" data-id="element-4418">
                        conditions générales
                      </Link>{' '}
                      et la{' '}
                      <Link to="/politique-confidentialite" className="text-blue-600 hover:text-blue-800" data-id="element-4419">
                        politique de confidentialité
                      </Link>{' '}
                      *
                    </label>
                  </div>
                  <div className="flex items-start" data-id="element-4420">
                    <input type="checkbox" id="newsletter" name="newsletter" checked={formData.newsletter} onChange={handleChange} className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mt-1" data-id="element-4421" />
                    <label htmlFor="newsletter" className="ml-2 block text-sm text-gray-700" data-id="element-4422">
                      Je souhaite recevoir les actualités et offres spéciales
                      par email
                    </label>
                  </div>
                </div>
                <div data-id="element-4423">
                  <Button variant="secondary" fullWidth type="submit" className="shadow-md" size="lg" data-id="element-4424">
                    Commencer l'essai gratuit
                  </Button>
                </div>
                <p className="text-xs text-gray-500 text-center" data-id="element-4425">
                  * Champs obligatoires. En vous inscrivant, vous acceptez que
                  vos données soient traitées conformément à notre politique de
                  confidentialité.
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
      <footer className="bg-gray-50 border-t border-gray-200 py-8 mt-12" data-id="element-4426">
        <div className="container mx-auto px-4" data-id="element-4427">
          <div className="text-center text-sm text-gray-600" data-id="element-4428">
            <p className="mb-2" data-id="element-4429">© 2025 ElevateIT. Tous droits réservés.</p>
            <div className="flex justify-center space-x-4" data-id="element-4430">
              <Link to="/mentions-legales" className="hover:text-blue-600" data-id="element-4431">
                Mentions légales
              </Link>
              <Link to="/politique-confidentialite" className="hover:text-blue-600" data-id="element-4432">
                Confidentialité
              </Link>
              <Link to="/cgv" className="hover:text-blue-600" data-id="element-4433">
                CGV
              </Link>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}